import config from 'config';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import {
  isF2F,
  isClosedAppointment,
  isConversationParticipant,
} from 'modules/appointmentInfo/selectors/currentAppointment';
import {
  isInWaitingRoom,
  conferenceStopping,
  conferenceInProgress,
} from 'modules/conference/selectors/consultationInfo';

import {
  RECONNECTION,
  ALLOW_CAMERA,
  WAITING_ROOM,
  DENIED_CAMERA,
  F2F_PLACEHOLDER,
  WAIT_CONNECTION,
  CLALIT_WAITING_ROOM,
  WAIT_STOP_CONNECTION,
  APPOINTMENT_DESCRIPTION,
} from '../constants/videoLayoutTypes';


const isClalit = config.product_name === 'clalit';

export const videoLayoutBackgroundKey = (state) => {
  const { localMediaPermission } = state.common.browserMediaPermissions;
  const { reconnection, consultationEstablishedAtLeastOneTime } = state.conference.consultationLifecycle;
  const { pending, failure } = requestsStatuses;

  switch (localMediaPermission) {
    case pending:
      return DENIED_CAMERA;
    case failure:
      return ALLOW_CAMERA;
    default:
      break;
  }

  if (conferenceInProgress(state) && isConversationParticipant(state)) {
    switch (true) {
      case isInWaitingRoom(state):
        return WAITING_ROOM;

      case reconnection && consultationEstablishedAtLeastOneTime:
        return RECONNECTION;

      case conferenceStopping(state):
        return WAIT_STOP_CONNECTION;

      default:
        return WAIT_CONNECTION;
    }
  }

  if (isF2F(state) && !isClosedAppointment(state)) return F2F_PLACEHOLDER;

  return isClalit ? CLALIT_WAITING_ROOM : APPOINTMENT_DESCRIPTION;
};
